export enum PushCampaignType {
  NotificationLink = 'notification_link',
  NotificationReward = 'notification_reward',
}

export const PUSH_CAMPAIGN_TYPE_OPTIONS = [
  { label: 'Thông báo + liên kết', value: PushCampaignType.NotificationLink },
  { label: 'Thông báo + điểm thưởng', value: PushCampaignType.NotificationReward },
]

